<script setup>
import { scroll } from "@/core/helpers/scrollTo.js";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

const route = useRoute();
const router = useRouter();
const menuOpen = ref(false);

const currentYear = new Date().getFullYear();

const scrollTo = (id, routeName) => {
  menuOpen.value = false;
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({ name: "home" }).then(() => scroll(id, 300));
  }
};
</script>

<template>
  <footer class="footer">
    <div class="inner">
      <div class="container">
        <div class="footer__wrapper">
          <div class="footer__wrapper-left">
            <router-link :to="{ name: 'home' }">
              <img src="@images/logo-footer.png" alt="" style="width: 224px" />
            </router-link>
            <div class="footer__wrapper-column">
              <h3>Contacts</h3>
              <p>
                <a href="mailto:info@gold-charge.com">info@gold-charge.com</a>
              </p>
              <p>
                <span
                >Suite 28, Wolverhampton, 84 Salop str., WV3 0SR, England</span
                >
              </p>
            </div>
          </div>
          <div class="footer__wrapper-right">
            <div class="footer__wrapper-column">
              <h3>Navigation</h3>
              <button @click="scrollTo('about', 'home')">About us</button>
              <button @click="scrollTo('benefits', 'home')">Benefits</button>
              <button @click="scrollTo('contact', 'home')">Contact us</button>
            </div>
            <div class="footer__wrapper-column">
              <h3>Documents</h3>
              <button>
                <router-link :to="{ name: 'privacyPolicy' }">
                  Privacy Policy
                </router-link>
              </button>
              <button>
                <router-link :to="{ name: 'terms-of-use' }">
                  Terms of Use
                </router-link>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="footer-bottom">
        <p style="font-size: 18px">
          SOFTWAREERA LTD © {{ currentYear }}. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
h3 {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-weight: 400;
  text-decoration-line: underline;
}

button {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-align: start;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: #ae8f72;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
}

a,
span {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 18px;
  font-weight: 400;
}

p {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 22px;
  font-weight: 400;
}

.inner {
  border-block: 2px solid #ae8f72;
  width: 100%;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-block: 50px;
    flex-wrap: wrap;
    gap: 40px;

    &-left {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 50px;
      flex-wrap: wrap;
    }

    &-column {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 15px;
    }

    &-right {
      display: flex;
      align-items: flex-start;
      gap: 100px;
      flex-wrap: wrap;
    }
  }

  &-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-block: 12px;
    text-align: center;
  }
}

/* ——— АДАПТИВ ——— */

@media (max-width: 1024px) {
  .footer__wrapper {
    flex-direction: column;
    align-items: center;
    text-align: center;

    &-left {
      flex-direction: column;
      align-items: center;
      gap: 30px;
    }

    &-right {
      justify-content: center;
      gap: 50px;
    }

    &-column {
      align-items: center;
    }
  }

  h3 {
    font-size: 18px;
  }

  p,
  a,
  span,
  button {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .footer__wrapper-right {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }

  .footer__wrapper-left img {
    width: 180px;
  }

  .footer-bottom p {
    font-size: 16px !important;
  }
}

@media (max-width: 480px) {
  h3 {
    font-size: 16px;
  }

  button,
  a,
  span,
  p {
    font-size: 14px;
  }

  .footer__wrapper {
    gap: 20px;
    padding-block: 30px;
  }

  .footer__wrapper-left img {
    width: 150px;
  }

  .footer__wrapper-right {
    gap: 25px;
  }

  .footer-bottom p {
    font-size: 14px !important;
  }
}
</style>
